import { Component } from "react";
import { compose } from "redux";

// markup
import CircularProgress from "@material-ui/core/CircularProgress";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";

// charts
import Highcharts from "react-highcharts";

import { statisticsConnector } from "../../../services/statistics/connector";

class DashboardStatisticsComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    let config;

    if (this.props.statistics.calculated) {
      config = this.props.statistics.chart;
    } else {
      config = {};
    }

    let chartOverlay = {
      width: "100%",
      height: "100%",
      zIndex: "999",
      position: "absolute",
      backgroundColor: "rgba(207, 207, 207, 0.73)",
      top: 0,
      left: 0,
      padding: "30px",
    };

    chartOverlay.display = !this.props.statistics.calculated ? "block" : "none";

    return (
      <div style={{ padding: "8px 16px" }}>
        <Card>
          <CardContent>
            <div
              className="dashboard-layout body-height content-padding"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
              }}
            >
              <div
                style={{
                  width: "100%",
                  height: "100%",
                  minHeight: "800px",
                  position: "relative",
                }}
              >
                <div style={chartOverlay}>
                  <CircularProgress size={120} thickness={8} />
                </div>
                <Highcharts config={config} />
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    );
  }
}
export const StatisticsTransactions = compose(statisticsConnector)(
  DashboardStatisticsComponent,
);
